module.exports = __webpack_public_path__ + "c969a026275a8981fd6ec7d76c3d7d1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/r-halo-image.png
// module id = 188
// module chunks = 0